<template>
  <div id="footer" class="container-fluid">
    <!-- <p class="address_tel_fax">
      <span>地址：公司地址</span>
      <span>Tel：888-888-888</span>
    </p>
    <p class="email_wx">
      <span>邮箱：xxx@163.com</span>
      <span>微信号：xxx</span>
    </p>
    <p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} 公司名称</p> -->
    <div class="row" v-if="screenWidth > 997">
      <div class="col-xs-12 col-sm-3 col-md-4 server-wrapper1">
        <div class="title">{{ $t("home.aboutUs") }}</div>
        <div class="sub-title">{{ $t("company.excellentQuality") }}</div>
        <div class="sub-title">{{ $t("company.since2010Sub") }}</div>
        <div class="sub-title">{{ $t("company.supportOEM") }}</div>
      </div>
      <div class="col-xs-12 col-sm-3 col-md-4 server-wrapper2">
        <div class="title">{{ $t("home.productClassification") }}</div>
        <div
          v-for="(i, index) in productList"
          @click="subClick(i)"
          :key="index"
          class="sub-title"
        >
          {{ i.name }}
        </div>
      </div>
      <div class="col-xs-12 col-sm-3 col-md-4 server-wrapper3">
        <div class="title">{{ $t("header.contactUs") }}</div>
        <div
          class="sub-title"
          style="justify-content: space-around;margin-bottom:20px;display:flex"
        >
          <a
            href="https://mp.weixin.qq.com/s/i8JdIIbXXDE5JEF0BMLGpw"
            target="_blank"
          >
            <img
              style="width:25px;height:25px"
              src="../assets/img/wechat.png"
            />
          </a>
          <img
            style="width:25px;height:25px"
            src="../assets/img/facebook.png"
          />
          <img
            style="width:25px;height:25px"
            src="../assets/img/linkedin.png"
          />
        </div>
        <div class="sub-title">E-Mail：info@skychems.com</div>
        <div class="sub-title">
          {{ $t("contactUs.address1") }}
        </div>
      </div>
    </div>

    <div class="rowM" style="margin-top:20px" v-else>
      <div class="col-xs-12 col-sm-3 col-md-4 server-wrapper1">
        <div class="title">{{ $t("home.aboutUs") }}</div>
        <div class="sub-title">{{ $t("company.excellentQuality") }}</div>
        <div class="sub-title">{{ $t("company.since2010Sub") }}</div>
        <div class="sub-title">{{ $t("company.supportOEM") }}</div>
      </div>
      <div class="col-xs-12 col-sm-3 col-md-4 server-wrapper2">
        <div class="title">{{ $t("home.productClassification") }}</div>
        <div
          v-for="(i, index) in productList"
          @click="subClick(i)"
          :key="index"
          class="sub-title"
        >
          {{ i.name }}
        </div>
      </div>
      <div class="col-xs-12 col-sm-3 col-md-4 server-wrapper3">
        <div class="title">{{ $t("header.contactUs") }}</div>
        <div
          class="sub-title"
          style="justify-content: space-around;margin-bottom:20px;display:flex"
        >
          <a
            href="https://mp.weixin.qq.com/s/i8JdIIbXXDE5JEF0BMLGpw"
            target="_blank"
          >
            <img
              style="width:25px;height:25px"
              src="../assets/img/wechat.png"
            />
          </a>
          <img
            style="width:25px;height:25px"
            src="../assets/img/facebook.png"
          />
          <img
            style="width:25px;height:25px"
            src="../assets/img/linkedin.png"
          />
        </div>
        <div class="sub-title">E-Mail：info@skychems.com</div>
        <div class="sub-title">
          {{ $t("contactUs.address1") }}
        </div>
      </div>
    </div>

    <div class="filingNumber">
      <img
        style="width:18px;height:18px;margin-right:10px;margin-top:1px"
        src="../assets/img/badge.jpg"
      />
      <a
        class="numberOne"
        href="https://beian.mps.gov.cn/#/query/webSearch?code=32011302321612"
        rel="noreferrer"
        target="_blank"
        >苏公网安备 32011302321612</a
      >
      <p class="line">|</p>
      <a
        class="numberOne"
        href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
        rel="noreferrer"
        target="_blank"
        >苏ICP备2023044081号</a
      >
    </div>
  </div>
</template>
<script>
import bus from "../utils/bus";
import { getProductCategory } from "../http/api/product.js";
export default {
  name: "Footer",
  data() {
    return {
      screenWidth: null,
      productList: []
    };
  },
  watch: {
    screenWidth: {
      handler: function(val) {
        if (val < 900) {
        } else {
        }
      },
      immediate: true,
      deep: true
    },
    "$i18n.locale"(newValue) {
      getProductCategory({
        current: 1,
        size: 99
      }).then(res => {
        if (this.$i18n.locale === "zh") {
          res.content.forEach(e => {
            e.path = "/product";
          });
          this.productList = res.content;
        } else {
          res.content.forEach(e => {
            e.path = "/product";
            e.name = e.nameEn;
          });
          this.productList = res.content;
        }
      });
    }
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;

    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };

    getProductCategory({
      current: 1,
      size: 99
    }).then(res => {
      if (this.$i18n.locale === "zh") {
        res.content.forEach(e => {
          e.path = "/product";
        });
        this.productList = res.content;
      } else {
        res.content.forEach(e => {
          e.path = "/product";
          e.name = e.nameEn;
        });
        this.productList = res.content;
      }
    });
  },
  methods: {
    subClick(item) {
      sessionStorage.setItem("navIndex", 1);
      bus.$emit("send", item);
      this.$router.push({
        path: "./product",
        query: {
          fCategory: item
        }
      });
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #ffffff;
  overflow: hidden;
  text-align: center;
}

#footer .row {
  padding: 50px 0px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  width: 100%;
}

#footer .title {
  color: rgb(0, 137, 205);
  font-size: 1.7rem;
  margin-bottom: 2rem;
  font-weight: 600;
}
#footer .titlePad {
  padding-left: 44.5%;
}
#footer .sub-title {
  color: rgb(0, 0, 0);
  font-size: 1.2rem;
  font-weight: 600;
  height: 3rem;
  text-align: center;
  display: block;
}
#footer .sub-title:hover {
  color: rgb(0, 137, 205);
  font-size: 1.2rem;
  font-weight: 600;
  height: 3rem;
  text-align: center;
  display: block;
  cursor: pointer;
}

.filingNumber {
  padding: 20px;
  display: flex;
  justify-content: center;
}
.filingNumber .numberOne {
  color: darkred;
}
.filingNumber .line {
  padding: 0 10px;
  color: #000;
  margin-top: -1px;
}
.filingNumber .numberTwo {
  color: #000000;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
  #footer .sub-title {
    color: rgb(0, 0, 0);
    font-size: 1.5rem;
    font-weight: 600;
    height: 3rem;
    text-align: center;
    display: block;
  }
  #footer .titlePad {
    padding-left: 0%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue